export enum CheckType {
    HTTP = "HTTP",
    TCP = "TCP"
}

export interface UptimeMonitor {
    uuid: string;
    name: string;
    description?: string;
    checkType: CheckType;
    // HTTP fields
    endpoint: string;
    method: string;
    headers: { [key: string]: string };
    body: string;
    expectedStatusCode: string;
    responseBodyRegex?: string;
    // TCP fields
    host?: string;
    port?: number;
    // Common fields
    checkFrequencySeconds: number;
    responseTimeMetricName: string;
    statusMetricName: string;
    metricNameBase?: string;
} 